module.exports = __webpack_public_path__ + "static/media/8.8eb4aeb8.jpg";